import { z } from 'zod'
import { IDocumentCategory } from '../Documents/types'
import { ICustomer } from '../types'
import { IDocumentType } from './types'

export const documentTypeSchema = z.object({
  id: z.number().optional().default(0),
  name: z.string().min(1, { message: 'Document type name is required' }),
  documentCategoryId: z
    .number({
      required_error: 'Document category is required',
      invalid_type_error: 'Document category must be a number',
    })
    .nullable(),
  tenantId: z.number().optional(),
  customerId: z.number().optional(),
  customer: z.custom<ICustomer>().optional(),
  documentCategory: z.custom<IDocumentCategory>().optional(),
  enabled: z.boolean().optional().default(true),
})

export type DocumentTypeFormValues = z.infer<typeof documentTypeSchema>

export const createEmptyDocumentType = (categoryId?: number): IDocumentType => ({
  id: 0,
  name: '',
  documentCategoryId: categoryId || 0,
})

export const isValidDocumentType = (value: unknown): value is IDocumentType => {
  return documentTypeSchema.safeParse(value).success
}

export const getDocumentTypeValidationSchema = () => {
  return documentTypeSchema
}
